import React from "react";
import { Alert } from "antd";
import { useSearchParams } from "react-router-dom";
import AppLayout from "../components/Layout";
import ScenarioCard, { TileGrid } from "../components/ScenarioCard";
import { SCENARIOS } from "../helper";

/**
 * Launches the installed VR app for a contact via its custom URL scheme
 * (e.g. lcds-medadmin://start-with?user-token=…). The token identifies the contact
 * so the headset can post results back to the API.
 */
const StartExperience = () => {
	const [params] = useSearchParams();
	const token = params.get("token");
	const name = params.get("name");

	const launch = (scenario) => {
		window.location.href = `${scenario.scheme}://start-with?user-token=${encodeURIComponent(token)}`;
	};

	return (
		<AppLayout
			title="Start experience"
			subtitle={name ? `Choose the scenario to launch for ${name}.` : "Choose the scenario to launch."}
		>
			{!token && (
				<Alert
					type="warning"
					showIcon
					style={{ marginBottom: 24 }}
					message="No contact selected"
					description="Open this page from the Contacts or Event contacts list so the scenario knows who is training."
				/>
			)}
			<TileGrid>
				{SCENARIOS.map((scenario) => (
					<ScenarioCard
						key={scenario.key}
						icon={scenario.icon}
						title={scenario.title}
						onClick={() => token && launch(scenario)}
					/>
				))}
			</TileGrid>
			<p style={{ textAlign: "center", color: "var(--lcds-muted)", marginTop: 24 }}>
				The scenario opens in the installed LCDS VR application on this computer.
			</p>
		</AppLayout>
	);
};

export default StartExperience;
